module.exports = __webpack_public_path__ + "static/media/3.6f8d32d8.jpg";